module.exports = __webpack_public_path__ + "static/media/IconAreaPreservada.0396ece7.svg";